import { Text } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'

const Span = styled(motion.custom(Text))()

export default Span

Span.defaultProps = {
  fontSize: 'md',
  color: 'text.300'
}
